import SchedulingScreen from "./SchedulingScreen/SchedulingScreen";
import { Box, Typography } from "@mui/material";
import styles from "./priestSchedule.module.scss";
import CustomDatePicker from "../../common/DatePicker/DatePicker";
import { useState } from "react";
import dayjs from "dayjs";
import { CustomRequiredInputLabel } from "../../common/StyledComponents/StyledFields";
import { useFormik } from "formik";
import CustomSelectField from "../../common/CustomSelectField/CustomSelectField";
import { useAppSelector } from "../../../app/hook";
import CustomizedSwitch from "../../common/CustomToggle/CustomToggle";
import { Toaster } from "react-hot-toast";
import { displayDateFormat } from "../../../infrastructure/backendService";

const priestDetailsStyles = {
  poojaBookingFieldContainer: {
    maxWidth: { xs: "100%", sm: "320px" },
    width: "320px",
    pr: { xs: "0px", sm: "15px" },
    mb: "10px",
  },
};

interface PriestWeeklyScheduleProps {
  setShowPriestSchedulingScreen?: (show: boolean) => void;
}

const PriestWeeklySchedule = (props: PriestWeeklyScheduleProps) => {
  const { priestsList, poojaDetails } = useAppSelector(
    (state) => state.poojaBookingDS
  );
  const [isDatePickerOpen, setDatePickerOpen] = useState(false);
  const initialData = {
    ...poojaDetails,
    date: poojaDetails?.dateOfPooja,
    time: poojaDetails?.poojaTime,
    priestId: poojaDetails?.priestId,
    allPriests: false,
  };
  const formik = useFormik({
    initialValues: initialData,
    onSubmit: (values) => {},
    enableReinitialize: true,
  });

  const getPriestName = (priest_id: string) => {
    const priestDetails = priestsList.find(
      (item: any) => item.priest_id === priest_id
    );

    return priestDetails?.priestname;
  };

  const handleDateChange = (field: string, value: any) => {
    const formattedDate = dayjs(value, "MM-DD-YYYY");
    const date = formattedDate.isValid()
      ? formattedDate.format("MM-DD-YYYY")
      : "";
    formik.setFieldValue(field, date);
  };

  const handleFieldChange = (field: string, value: any) => {
    formik.setFieldValue(field, value);
    if (field === "priestId") {
      formik.setFieldValue("priestName", getPriestName(value));
    }
  };

  const renderPoojaDetails = () => {
    return (
      <Box className={styles.poojaDetailsTableContainer}>
        <table className={styles.poojaDetailsTable}>
          <thead>
            <tr>
              <th>Priest ID</th>
              <th>Priest Full Name</th>
              <th>Devotee ID</th>
              <th>Pooja Name</th>
              <th>Pooja Type</th>
              <th>Devotee Requests Start Date</th>
              <th>Pooja Time Required</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{formik.values.priestId}</td>
              <td>{getPriestName(formik.values.priestId)}</td>
              <td>{poojaDetails?.devoteeID}</td>
              <td>{poojaDetails?.poojaName}</td>
              <td>
                {poojaDetails?.poojaLocation === "OUTSIDE_POOJA"
                  ? "Outside Pooja"
                  : "Temple Pooja"}
              </td>
              <td>{displayDateFormat(new Date(formik.values.date))} {formik.values.time}</td>
              <td>{poojaDetails?.poojaDuration} Minutes</td>
            </tr>
          </tbody>
        </table>
      </Box>
    );
  };

  const renderPriestAndPoojaDetails = () => {
    return (
      <Box className={styles.priest_details_main_container}>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
          }}
        >
          <Box sx={priestDetailsStyles.poojaBookingFieldContainer}>
            {CustomRequiredInputLabel("Date", false)}
            <CustomDatePicker
              isDatePickerOpen={isDatePickerOpen}
              setDatePickerOpen={setDatePickerOpen}
              date={formik.values.date}
              handleDateChange={handleDateChange}
              errorMessage={formik.errors.date}
            />
          </Box>
          {!formik.values.allPriests && (
            <>
              <Box sx={priestDetailsStyles.poojaBookingFieldContainer}>
                {CustomRequiredInputLabel("Select Priest", false)}
                <CustomSelectField
                  handleDropdowmChange={handleFieldChange}
                  errorMessage={formik.errors.priestId}
                  dropDownList={priestsList}
                  value={formik.values.priestId}
                  fieldName="priestId"
                  placeholder={"Select priest"}
                  optionLabel={"priestname"}
                  optionValue={"priest_id"}
                />
              </Box>
            </>
          )}
          <Box
            sx={{
              ...priestDetailsStyles.poojaBookingFieldContainer,
              pt: "17px",
              display: "flex",
              alignItems: "center",
              height: "54px",
            }}
          >
            <Typography className={styles.toggle_priest_text} mr="13px">
              Priest
            </Typography>
            <CustomizedSwitch
              fieldName={"allPriests"}
              isChecked={formik.values.allPriests}
              handleChange={handleFieldChange}
            />
            <Typography className={styles.toggle_priest_text} ml="13px">
              All Priests
            </Typography>
          </Box>
        </Box>
        {renderPoojaDetails()}
      </Box>
    );
  };

  return (
    <>
      <Toaster />
      {renderPriestAndPoojaDetails()}
      <SchedulingScreen
        formik={formik}
        setShowPriestSchedulingScreen={props?.setShowPriestSchedulingScreen}
      />
    </>
  );
};

export default PriestWeeklySchedule;
